import { Typography } from '@mui/material'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { Entity, Persisted } from '@tunasong/schemas'
import { useRecent } from '@tunasong/search'
import { EntityGrid, EntityList, useDimensions, useNavigateToEntity } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'

export interface RecentProps {
  /** Entities to exclude from the list, e.g., if they are already shown */
  exclude?: Persisted<Entity>[]
  /** Title of the recent list */
  title?: string
  type?: 'grid' | 'list'
}

export const RecentActivity: FC<RecentProps> = props => {
  const { exclude, title, type = 'list' } = props
  const navigateToEntity = useNavigateToEntity()
  const { isTiny } = useDimensions()
  const steps = isTiny ? 2 : 3
  const [rows] = useState(2)

  const maxCount = type === 'grid' ? rows * steps : 30

  const { isLoading: isSearching, searchResults } = useRecent({ exclude, maxCount })

  const entityIds = searchResults.slice(0, maxCount).map(e => e.id)
  const { existingEntities: entities, isLoading } = graphHooks.useEntitiesById(entityIds)

  const loading = (isSearching || isLoading) && entities.length === 0

  const filteredEntities = entities.filter(e => !e.trash).sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))

  return (
    <>
      {title ? <Typography variant="subtitle1">{title}</Typography> : null}
      {type === 'grid' ? (
        <EntityGrid
          sx={{ pt: theme => theme.spacing(1), pb: theme => theme.spacing(4) }}
          size="small"
          skeletonItems={maxCount}
          placeholder="No recent activities found"
          entities={filteredEntities}
          loading={loading}
          onOpen={navigateToEntity}
        />
      ) : (
        <EntityList
          sx={{
            maxHeight: '40vh',
            overflowY: 'auto',
            paddingBottom: theme => theme.spacing(12),
            // Fade out the bottom of the list
            maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
          }}
          showBreadcrumbs={true}
          entities={filteredEntities}
          onOpen={navigateToEntity}
          size="tiny"
          actions={false}
        />
      )}
    </>
  )
}
